module.exports = __webpack_public_path__ + "img/userInformatica2.14accb84.png";